import { FiltersMap } from '../model';
import { CustomTotalFn, SaveAsFn, TransformQuery } from '../state';
import { useState } from 'react';
import {
  ArrayFieldDelimiter,
  CreateExportAsyncJobRequest,
  MethodMetadata,
  MethodSpec,
  QueryFieldNumber,
} from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export interface UseExportConfigParams<T, F extends FiltersMap> {
  transformPlatformizedQuery?: TransformQuery<T, F>;
  differentQueryEndpointThanCollection?: boolean;
  customTotal?: CustomTotalFn<T, F>;
  methodMetadata: MethodMetadata;
  arrayFieldDelimiter?: keyof typeof ArrayFieldDelimiter;
  methodSpec?: {
    requestQueryFieldNumber?: keyof typeof QueryFieldNumber;
    responsePagingMetadataFieldName?: MethodSpec['responsePagingMetadataFieldName'];
    responseRepeatedFieldName?: MethodSpec['responseRepeatedFieldName'];
  };
  fields: CreateExportAsyncJobRequest['fields'];
  saveAs?: SaveAsFn<T, F>;
}

export function useExportConfig<T, F extends FiltersMap>(
  params: UseExportConfigParams<T, F>,
) {
  const [config] = useState(() => params);

  return config;
}
